import React from "react";
export default function MyComponent() {
  const html = `
  <html><head><meta http-equiv="Content-Type" content="text/html; charset=utf-8"/><title>RefMonkey Wiki &amp; Help Center</title><style>
/* webkit printing magic: print all background colors */
html {
	-webkit-print-color-adjust: exact;
}
* {
	box-sizing: border-box;
	-webkit-print-color-adjust: exact;
}

html,
body {
	margin: 0;
	padding: 0;
}
@media only screen {
	body {
		margin: 2em auto;
		max-width: 900px;
		color: rgb(55, 53, 47);
	}
}

body {
	line-height: 1.5;
	white-space: pre-wrap;
}

a,
a.visited {
	color: inherit;
	text-decoration: underline;
}

.pdf-relative-link-path {
	font-size: 80%;
	color: #444;
}

h1,
h2,
h3 {
	letter-spacing: -0.01em;
	line-height: 1.2;
	font-weight: 600;
	margin-bottom: 0;
}

.page-title {
	font-size: 2.5rem;
	font-weight: 700;
	margin-top: 0;
	margin-bottom: 0.75em;
}

h1 {
	font-size: 1.875rem;
	margin-top: 1.875rem;
}

h2 {
	font-size: 1.5rem;
	margin-top: 1.5rem;
}

h3 {
	font-size: 1.25rem;
	margin-top: 1.25rem;
}

.source {
	border: 1px solid #ddd;
	border-radius: 3px;
	padding: 1.5em;
	word-break: break-all;
}

.callout {
	border-radius: 3px;
	padding: 1rem;
}

figure {
	margin: 1.25em 0;
	page-break-inside: avoid;
}

figcaption {
	opacity: 0.5;
	font-size: 85%;
	margin-top: 0.5em;
}

mark {
	background-color: transparent;
}

.indented {
	padding-left: 1.5em;
}

hr {
	background: transparent;
	display: block;
	width: 100%;
	height: 1px;
	visibility: visible;
	border: none;
	border-bottom: 1px solid rgba(55, 53, 47, 0.09);
}

img {
	max-width: 100%;
}

@media only print {
	img {
		max-height: 100vh;
		object-fit: contain;
	}
}

@page {
	margin: 1in;
}

.collection-content {
	font-size: 0.875rem;
}

.column-list {
	display: flex;
	justify-content: space-between;
}

.column {
	padding: 0 1em;
}

.column:first-child {
	padding-left: 0;
}

.column:last-child {
	padding-right: 0;
}

.table_of_contents-item {
	display: block;
	font-size: 0.875rem;
	line-height: 1.3;
	padding: 0.125rem;
}

.table_of_contents-indent-1 {
	margin-left: 1.5rem;
}

.table_of_contents-indent-2 {
	margin-left: 3rem;
}

.table_of_contents-indent-3 {
	margin-left: 4.5rem;
}

.table_of_contents-link {
	text-decoration: none;
	opacity: 0.7;
	border-bottom: 1px solid rgba(55, 53, 47, 0.18);
}

table,
th,
td {
	border: 1px solid rgba(55, 53, 47, 0.09);
	border-collapse: collapse;
}

table {
	border-left: none;
	border-right: none;
}

th,
td {
	font-weight: normal;
	padding: 0.25em 0.5em;
	line-height: 1.5;
	min-height: 1.5em;
	text-align: left;
}

th {
	color: rgba(55, 53, 47, 0.6);
}

ol,
ul {
	margin: 0;
	margin-block-start: 0.6em;
	margin-block-end: 0.6em;
}

li > ol:first-child,
li > ul:first-child {
	margin-block-start: 0.6em;
}

ul > li {
	list-style: disc;
}

ul.to-do-list {
	text-indent: -1.7em;
}

ul.to-do-list > li {
	list-style: none;
}

.to-do-children-checked {
	text-decoration: line-through;
	opacity: 0.375;
}

ul.toggle > li {
	list-style: none;
}

ul {
	padding-inline-start: 1.7em;
}

ul > li {
	padding-left: 0.1em;
}

ol {
	padding-inline-start: 1.6em;
}

ol > li {
	padding-left: 0.2em;
}

.mono ol {
	padding-inline-start: 2em;
}

.mono ol > li {
	text-indent: -0.4em;
}

.toggle {
	padding-inline-start: 0em;
	list-style-type: none;
}

/* Indent toggle children */
.toggle > li > details {
	padding-left: 1.7em;
}

.toggle > li > details > summary {
	margin-left: -1.1em;
}

.selected-value {
	display: inline-block;
	padding: 0 0.5em;
	background: rgba(206, 205, 202, 0.5);
	border-radius: 3px;
	margin-right: 0.5em;
	margin-top: 0.3em;
	margin-bottom: 0.3em;
	white-space: nowrap;
}

.collection-title {
	display: inline-block;
	margin-right: 1em;
}

time {
	opacity: 0.5;
}

.icon {
	display: inline-block;
	max-width: 1.2em;
	max-height: 1.2em;
	text-decoration: none;
	vertical-align: text-bottom;
	margin-right: 0.5em;
}

img.icon {
	border-radius: 3px;
}

.user-icon {
	width: 1.5em;
	height: 1.5em;
	border-radius: 100%;
	margin-right: 0.5rem;
}

.user-icon-inner {
	font-size: 0.8em;
}

.text-icon {
	border: 1px solid #000;
	text-align: center;
}

.page-cover-image {
	display: block;
	object-fit: cover;
	width: 100%;
	height: 30vh;
}

.page-header-icon {
	font-size: 3rem;
	margin-bottom: 1rem;
}

.page-header-icon-with-cover {
	margin-top: -0.72em;
	margin-left: 0.07em;
}

.page-header-icon img {
	border-radius: 3px;
}

.link-to-page {
	margin: 1em 0;
	padding: 0;
	border: none;
	font-weight: 500;
}

p > .user {
	opacity: 0.5;
}

td > .user,
td > time {
	white-space: nowrap;
}

input[type="checkbox"] {
	transform: scale(1.5);
	margin-right: 0.6em;
	vertical-align: middle;
}

p {
	margin-top: 0.5em;
	margin-bottom: 0.5em;
}

.image {
	border: none;
	margin: 1.5em 0;
	padding: 0;
	border-radius: 0;
	text-align: center;
}

.code,
code {
	background: rgba(135, 131, 120, 0.15);
	border-radius: 3px;
	padding: 0.2em 0.4em;
	border-radius: 3px;
	font-size: 85%;
	tab-size: 2;
}

code {
	color: #eb5757;
}

.code {
	padding: 1.5em 1em;
}

.code-wrap {
	white-space: pre-wrap;
	word-break: break-all;
}

.code > code {
	background: none;
	padding: 0;
	font-size: 100%;
	color: inherit;
}

blockquote {
	font-size: 1.25em;
	margin: 1em 0;
	padding-left: 1em;
	border-left: 3px solid rgb(55, 53, 47);
}

.bookmark {
	text-decoration: none;
	max-height: 8em;
	padding: 0;
	display: flex;
	width: 100%;
	align-items: stretch;
}

.bookmark-title {
	font-size: 0.85em;
	overflow: hidden;
	text-overflow: ellipsis;
	height: 1.75em;
	white-space: nowrap;
}

.bookmark-text {
	display: flex;
	flex-direction: column;
}

.bookmark-info {
	flex: 4 1 180px;
	padding: 12px 14px 14px;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
}

.bookmark-image {
	width: 33%;
	flex: 1 1 180px;
	display: block;
	position: relative;
	object-fit: cover;
	border-radius: 1px;
}

.bookmark-description {
	color: rgba(55, 53, 47, 0.6);
	font-size: 0.75em;
	overflow: hidden;
	max-height: 4.5em;
	word-break: break-word;
}

.bookmark-href {
	font-size: 0.75em;
	margin-top: 0.25em;
}

.sans { font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, "Apple Color Emoji", Arial, sans-serif, "Segoe UI Emoji", "Segoe UI Symbol"; }
.code { font-family: "SFMono-Regular", Consolas, "Liberation Mono", Menlo, Courier, monospace; }
.serif { font-family: Lyon-Text, Georgia, YuMincho, "Yu Mincho", "Hiragino Mincho ProN", "Hiragino Mincho Pro", "Songti TC", "Songti SC", "SimSun", "Nanum Myeongjo", NanumMyeongjo, Batang, serif; }
.mono { font-family: iawriter-mono, Nitti, Menlo, Courier, monospace; }
.pdf .sans { font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, "Apple Color Emoji", Arial, sans-serif, "Segoe UI Emoji", "Segoe UI Symbol", 'Twemoji', 'Noto Color Emoji', 'Noto Sans CJK SC', 'Noto Sans CJK KR'; }

.pdf .code { font-family: Source Code Pro, "SFMono-Regular", Consolas, "Liberation Mono", Menlo, Courier, monospace, 'Twemoji', 'Noto Color Emoji', 'Noto Sans Mono CJK SC', 'Noto Sans Mono CJK KR'; }

.pdf .serif { font-family: PT Serif, Lyon-Text, Georgia, YuMincho, "Yu Mincho", "Hiragino Mincho ProN", "Hiragino Mincho Pro", "Songti TC", "Songti SC", "SimSun", "Nanum Myeongjo", NanumMyeongjo, Batang, serif, 'Twemoji', 'Noto Color Emoji', 'Noto Sans CJK SC', 'Noto Sans CJK KR'; }

.pdf .mono { font-family: PT Mono, iawriter-mono, Nitti, Menlo, Courier, monospace, 'Twemoji', 'Noto Color Emoji', 'Noto Sans Mono CJK SC', 'Noto Sans Mono CJK KR'; }

.highlight-default {
}
.highlight-gray {
	color: rgb(155,154,151);
}
.highlight-brown {
	color: rgb(100,71,58);
}
.highlight-orange {
	color: rgb(217,115,13);
}
.highlight-yellow {
	color: rgb(223,171,1);
}
.highlight-teal {
	color: rgb(15,123,108);
}
.highlight-blue {
	color: rgb(11,110,153);
}
.highlight-purple {
	color: rgb(105,64,165);
}
.highlight-pink {
	color: rgb(173,26,114);
}
.highlight-red {
	color: rgb(224,62,62);
}
.highlight-gray_background {
	background: rgb(235,236,237);
}
.highlight-brown_background {
	background: rgb(233,229,227);
}
.highlight-orange_background {
	background: rgb(250,235,221);
}
.highlight-yellow_background {
	background: rgb(251,243,219);
}
.highlight-teal_background {
	background: rgb(221,237,234);
}
.highlight-blue_background {
	background: rgb(221,235,241);
}
.highlight-purple_background {
	background: rgb(234,228,242);
}
.highlight-pink_background {
	background: rgb(244,223,235);
}
.highlight-red_background {
	background: rgb(251,228,228);
}
.block-color-default {
	color: inherit;
	fill: inherit;
}
.block-color-gray {
	color: rgba(55, 53, 47, 0.6);
	fill: rgba(55, 53, 47, 0.6);
}
.block-color-brown {
	color: rgb(100,71,58);
	fill: rgb(100,71,58);
}
.block-color-orange {
	color: rgb(217,115,13);
	fill: rgb(217,115,13);
}
.block-color-yellow {
	color: rgb(223,171,1);
	fill: rgb(223,171,1);
}
.block-color-teal {
	color: rgb(15,123,108);
	fill: rgb(15,123,108);
}
.block-color-blue {
	color: rgb(11,110,153);
	fill: rgb(11,110,153);
}
.block-color-purple {
	color: rgb(105,64,165);
	fill: rgb(105,64,165);
}
.block-color-pink {
	color: rgb(173,26,114);
	fill: rgb(173,26,114);
}
.block-color-red {
	color: rgb(224,62,62);
	fill: rgb(224,62,62);
}
.block-color-gray_background {
	background: rgb(235,236,237);
}
.block-color-brown_background {
	background: rgb(233,229,227);
}
.block-color-orange_background {
	background: rgb(250,235,221);
}
.block-color-yellow_background {
	background: rgb(251,243,219);
}
.block-color-teal_background {
	background: rgb(221,237,234);
}
.block-color-blue_background {
	background: rgb(221,235,241);
}
.block-color-purple_background {
	background: rgb(234,228,242);
}
.block-color-pink_background {
	background: rgb(244,223,235);
}
.block-color-red_background {
	background: rgb(251,228,228);
}
.select-value-color-default { background-color: rgba(206,205,202,0.5); }
.select-value-color-gray { background-color: rgba(155,154,151, 0.4); }
.select-value-color-brown { background-color: rgba(140,46,0,0.2); }
.select-value-color-orange { background-color: rgba(245,93,0,0.2); }
.select-value-color-yellow { background-color: rgba(233,168,0,0.2); }
.select-value-color-green { background-color: rgba(0,135,107,0.2); }
.select-value-color-blue { background-color: rgba(0,120,223,0.2); }
.select-value-color-purple { background-color: rgba(103,36,222,0.2); }
.select-value-color-pink { background-color: rgba(221,0,129,0.2); }
.select-value-color-red { background-color: rgba(255,0,26,0.2); }

.checkbox {
	display: inline-flex;
	vertical-align: text-bottom;
	width: 16;
	height: 16;
	background-size: 16px;
	margin-left: 2px;
	margin-right: 5px;
}

.checkbox-on {
	background-image: url("data:image/svg+xml;charset=UTF-8,%3Csvg%20width%3D%2216%22%20height%3D%2216%22%20viewBox%3D%220%200%2016%2016%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0A%3Crect%20width%3D%2216%22%20height%3D%2216%22%20fill%3D%22%2358A9D7%22%2F%3E%0A%3Cpath%20d%3D%22M6.71429%2012.2852L14%204.9995L12.7143%203.71436L6.71429%209.71378L3.28571%206.2831L2%207.57092L6.71429%2012.2852Z%22%20fill%3D%22white%22%2F%3E%0A%3C%2Fsvg%3E");
}

.checkbox-off {
	background-image: url("data:image/svg+xml;charset=UTF-8,%3Csvg%20width%3D%2216%22%20height%3D%2216%22%20viewBox%3D%220%200%2016%2016%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0A%3Crect%20x%3D%220.75%22%20y%3D%220.75%22%20width%3D%2214.5%22%20height%3D%2214.5%22%20fill%3D%22white%22%20stroke%3D%22%2336352F%22%20stroke-width%3D%221.5%22%2F%3E%0A%3C%2Fsvg%3E");
}
	
</style></head><body><article id="dfaa6ddf-f3bd-4feb-a51b-d40cb086450d" class="page sans"><header><div class="page-header-icon undefined"><span class="icon">🐵</span></div><h1 class="page-title">RefMonkey Wiki &amp; Help Center</h1></header><div class="page-body"><p id="497b625d-16f9-401c-8f8d-1b588eb7b5b2" class="">
</p><p id="6d71e22d-9117-4aeb-90aa-b8b6091a4dfe" class="">Below are some of the docs to help you get started and using all of the features on Refmonkey. If you need help feel free to email our support team at <mark class="highlight-purple"><span style="border-bottom:0.05em solid">help@refmonkey.com</span></mark><mark class="highlight-purple"> </mark>🙂</p><p id="9b06f93e-0727-4a4a-9838-8efe71f4f704" class="">
</p><ol id="5c6ff0ff-3c47-437b-aafd-4cf4de9b2b4b" class="numbered-list" start="1"><li>Guides in <span style="border-bottom:0.05em solid"><mark class="highlight-teal">green</mark></span> and <span style="border-bottom:0.05em solid"><mark class="highlight-orange">orange</mark></span> have full Refmonkey articles and guides</li></ol><ol id="68058c0a-2e0c-4b60-a0f3-88a811f0c7e1" class="numbered-list" start="2"><li>Guides in <span style="border-bottom:0.05em solid"><strong>black</strong></span> are features available on Refmonkey but we have not yet started on creating a guide on them yet, if you&#x27;d like to set them up feel free to email us and we can help.</li></ol><p id="aa110870-e8fb-419f-8383-c4add971333a" class="">
</p><h3 id="26eed983-2f5b-492c-874b-3311063ee73c" class=""><strong>Getting Started</strong></h3><figure id="d9f6cb96-a31d-4bbd-908d-4e74511b299f" class="block-color-teal link-to-page"><a href="RefMonkey%20Wiki%20&amp;%20Help%20Center%20dfaa6ddff3bd4feba51bd40cb086450d/Getting%20started%20with%20Refmonkey%20d9f6cb96a31d4bbd908d4e74511b299f.html">Getting started with Refmonkey</a></figure><figure id="c9e1abe1-15a0-4fb6-91a5-87dbbda15d17" class="block-color-teal link-to-page"><a href="RefMonkey%20Wiki%20&amp;%20Help%20Center%20dfaa6ddff3bd4feba51bd40cb086450d/Create%20a%20referral%20or%20affiliate%20system%20on%20a%20custom-%20c9e1abe115a04fb691a587dbbda15d17.html">Create a referral or affiliate system on a custom-coded website</a></figure><figure id="34288c74-8bcc-4a12-afe8-cfa7b9022c98" class="block-color-teal link-to-page"><a href="RefMonkey%20Wiki%20&amp;%20Help%20Center%20dfaa6ddff3bd4feba51bd40cb086450d/Create%20a%20referral%20or%20affiliate%20system%20on%20Wordpress%2034288c748bcc4a12afe8cfa7b9022c98.html">Create a referral or affiliate system on Wordpress sites [Latest]</a></figure><figure id="09ecd1b1-6673-45b6-9c83-3ffb0c152da7" class="block-color-orange link-to-page"><a href="RefMonkey%20Wiki%20&amp;%20Help%20Center%20dfaa6ddff3bd4feba51bd40cb086450d/Create%20a%20referral%20or%20affiliate%20system%20on%20Wordpress%2009ecd1b1667345b69c833ffb0c152da7.html">Create a referral or affiliate system on Wordpress sites [Legacy]</a></figure><figure id="4799ddb6-3056-4e76-8e09-89c3d5145695" class="block-color-orange link-to-page"><a href="RefMonkey%20Wiki%20&amp;%20Help%20Center%20dfaa6ddff3bd4feba51bd40cb086450d/Create%20a%20referral%20or%20affiliate%20system%20on%20Webflow%204799ddb630564e768e0989c3d5145695.html">Create a referral or affiliate system on Webflow</a></figure><figure id="03b33f42-54fe-483d-9ca1-7419c4b5b677" class="block-color-orange link-to-page"><a href="RefMonkey%20Wiki%20&amp;%20Help%20Center%20dfaa6ddff3bd4feba51bd40cb086450d/Create%20a%20referral%20or%20affiliate%20system%20on%20Shopify%2003b33f4254fe483d9ca17419c4b5b677.html">Create a referral or affiliate system on Shopify</a></figure><figure id="9dcf652d-8df5-411a-8591-d27709b0c6f5" class="block-color-orange link-to-page"><a href="RefMonkey%20Wiki%20&amp;%20Help%20Center%20dfaa6ddff3bd4feba51bd40cb086450d/Create%20a%20referral%20or%20affiliate%20system%20on%20Squarespa%209dcf652d8df5411a8591d27709b0c6f5.html">Create a referral or affiliate system on Squarespace websites</a></figure><figure id="47efedca-fb2e-4eaa-9f29-eedd2d000f5d" class="block-color-orange link-to-page"><a href="RefMonkey%20Wiki%20&amp;%20Help%20Center%20dfaa6ddff3bd4feba51bd40cb086450d/Create%20a%20referral%20or%20affiliate%20system%20on%20Wix%2047efedcafb2e4eaa9f29eedd2d000f5d.html">Create a referral or affiliate system on Wix</a></figure><figure id="2007b20d-81e6-4cb8-a240-2edb3a1e85a7" class="block-color-orange link-to-page"><a href="RefMonkey%20Wiki%20&amp;%20Help%20Center%20dfaa6ddff3bd4feba51bd40cb086450d/Using%20Zapier%20with%20Refmonkey%202007b20d81e64cb8a2402edb3a1e85a7.html">Using Zapier with Refmonkey</a></figure><figure id="7afd6726-d38a-4ffa-9ac9-bc35c953a029" class="block-color-orange link-to-page"><a href="RefMonkey%20Wiki%20&amp;%20Help%20Center%20dfaa6ddff3bd4feba51bd40cb086450d/Refmonkey%20API%20Docs%207afd6726d38a4ffa9ac9bc35c953a029.html">Refmonkey API Docs</a></figure><figure id="76f99bc5-1a7e-45d2-8693-f4d391cb0dbc" class="link-to-page"><a href="RefMonkey%20Wiki%20&amp;%20Help%20Center%20dfaa6ddff3bd4feba51bd40cb086450d/How%20to%20setup%20Refmonkey%20with%20Paddle%20subscriptions%20t%2076f99bc51a7e45d28693f4d391cb0dbc.html">How to setup Refmonkey with Paddle subscriptions to record referrals</a></figure><figure id="41c4ec97-7a42-4fe7-926a-9639f7875ca8" class="link-to-page"><a href="RefMonkey%20Wiki%20&amp;%20Help%20Center%20dfaa6ddff3bd4feba51bd40cb086450d/Create%20a%20referral%20or%20affiliate%20system%20on%20a%20email%20n%2041c4ec977a424fe7926a9639f7875ca8.html">Create a referral or affiliate system on a email newsletter</a></figure><figure id="463756a1-1572-4eca-bb60-837cbf0c9047" class="link-to-page"><a href="RefMonkey%20Wiki%20&amp;%20Help%20Center%20dfaa6ddff3bd4feba51bd40cb086450d/Create%20a%20referral%20or%20affiliate%20system%20on%20Woocommer%20463756a115724ecabb60837cbf0c9047.html">Create a referral or affiliate system on Woocommerce</a></figure><figure id="be19bfc1-45d7-4856-b79f-670ab75acef4" class="link-to-page"><a href="RefMonkey%20Wiki%20&amp;%20Help%20Center%20dfaa6ddff3bd4feba51bd40cb086450d/Create%20a%20referral%20or%20affiliate%20system%20on%20BigCommer%20be19bfc145d74856b79f670ab75acef4.html">Create a referral or affiliate system on BigCommerce</a></figure><h3 id="7cfef697-45fa-4bd8-a810-74a113eedd11" class="">Features</h3><figure id="8facf608-12d0-4ca7-a5a1-2af2aea4fe24" class="block-color-teal link-to-page"><a href="RefMonkey%20Wiki%20&amp;%20Help%20Center%20dfaa6ddff3bd4feba51bd40cb086450d/How%20to%20enable%20manual%20approval%20for%20each%20affiliate%208facf60812d04ca7a5a12af2aea4fe24.html">How to enable manual approval for each affiliate</a></figure><figure id="88ef6a8f-2aed-4a96-a21d-6b2305d4e579" class="block-color-teal link-to-page"><a href="RefMonkey%20Wiki%20&amp;%20Help%20Center%20dfaa6ddff3bd4feba51bd40cb086450d/How%20to%20view%20all%20successful%20referrals%2088ef6a8f2aed4a96a21d6b2305d4e579.html">How to view all successful referrals</a></figure><figure id="4d37de96-f9c3-4982-867d-546159a92d93" class="block-color-teal link-to-page"><a href="RefMonkey%20Wiki%20&amp;%20Help%20Center%20dfaa6ddff3bd4feba51bd40cb086450d/How%20to%20enable%20%25%20of%20sale%20payouts%20to%20affiliates%204d37de96f9c34982867d546159a92d93.html">How to enable % of sale payouts to affiliates</a></figure><figure id="eed18cf4-87b5-4555-b0f5-451c47994b14" class="block-color-teal link-to-page"><a href="RefMonkey%20Wiki%20&amp;%20Help%20Center%20dfaa6ddff3bd4feba51bd40cb086450d/How%20to%20pay%20your%20affiliates%20eed18cf487b54555b0f5451c47994b14.html">How to pay your affiliates</a></figure><figure id="89d0ce60-fda8-488b-90e5-bb6e14e28f5f" class="block-color-teal link-to-page"><a href="RefMonkey%20Wiki%20&amp;%20Help%20Center%20dfaa6ddff3bd4feba51bd40cb086450d/How%20to%20get%20Refmonkey%20Access%20Token%2089d0ce60fda8488b90e5bb6e14e28f5f.html">How to get Refmonkey Access Token</a></figure><figure id="00937a5f-befb-4ee2-a6ec-b22c059e2956" class="block-color-teal link-to-page"><a href="RefMonkey%20Wiki%20&amp;%20Help%20Center%20dfaa6ddff3bd4feba51bd40cb086450d/Changing%20account%20email%20or%20password%2000937a5fbefb4ee2a6ecb22c059e2956.html">Changing account email or password</a></figure><figure id="90b4aa91-52fe-47a4-98ed-d9a2469e6adb" class="block-color-teal link-to-page"><a href="RefMonkey%20Wiki%20&amp;%20Help%20Center%20dfaa6ddff3bd4feba51bd40cb086450d/Settling%20your%20affiliate%20payments%20via%20the%20API%2090b4aa9152fe47a498edd9a2469e6adb.html">Settling your affiliate payments via the API</a></figure><figure id="7775e17b-0c2b-4411-ab88-bbb05193cb5a" class="link-to-page"><a href="RefMonkey%20Wiki%20&amp;%20Help%20Center%20dfaa6ddff3bd4feba51bd40cb086450d/How%20to%20set%20up%20a%20signup%20page%20and%20dashboard%20for%20all%20%207775e17b0c2b4411ab88bbb05193cb5a.html">How to set up a signup page and dashboard for all your affiliates</a></figure><figure id="00626af5-008c-4f28-af6a-7d4b796482b6" class="link-to-page"><a href="RefMonkey%20Wiki%20&amp;%20Help%20Center%20dfaa6ddff3bd4feba51bd40cb086450d/Changing%20the%20language%20on%20Refmonkey%2000626af5008c4f28af6a7d4b796482b6.html">Changing the language on Refmonkey</a></figure><figure id="e5a44738-50cd-4b8e-a378-1a7958ad450f" class="link-to-page"><a href="RefMonkey%20Wiki%20&amp;%20Help%20Center%20dfaa6ddff3bd4feba51bd40cb086450d/Enabling%20collecting%20Paypal%20com%20info%20of%20affiliates%20e5a4473850cd4b8ea3781a7958ad450f.html">Enabling collecting Paypal.com info of affiliates</a></figure></div></article></body></html>`
  return (
        <div dangerouslySetInnerHTML={{ __html: html }} />
    );
}